<div class="second-container">
  <div class="small-container">
    <div
      class="club-universal contentTab"
      tabindex="0"
      role="button"
      (click)="getReservationDetails('hotel')"
      (keydown.enter)="getReservationDetails('hotel')"
      (keyup.Space)="getReservationDetails('hotel')"
      [attr.aria-label]="pageLabels?.['hotelReservation.title']"
    >
      <div class="align-left-hotel" aria-hidden="true">
        <div class="icon-container">
          <gds-svg
            [iconName]="pageLabels?.['dashboard.hotel_reservation_icon']"
            height="32"
            width="32"
            fill-color="#222"
            class="adventure"
          ></gds-svg>
          <gds-spacer classes="vertical-spacer-30"></gds-spacer>
        </div>
        <h2>
          <gds-heading
            class="B1-W4"
            classes="adventure"
            [data]="{
              heading: pageLabels?.['hotelReservation.title'],
            }"
          ></gds-heading>
        </h2>

        <div
          class="hotel-icon-names"
          (click)="getReservationDetails('hotel')"
          (keydown.enter)="getReservationDetails('hotel')"
          (keyup.Space)="getReservationDetails('hotel')"
        >
          <gds-spacer classes="vertical-spacer-20"></gds-spacer>
          <i aria-hidden="" class="icon icon-arrow-right"></i>
        </div>
      </div>
      @if (showUpcomingHotelReservations) {
        <h2 class="details-click" aria-hidden="true">
          <gds-heading
            class="A6-W4 adventure"
            [data]="{
              heading: pageLabels?.['dashboard.vacation_packages'],
            }"
          ></gds-heading>
        </h2>
      }
      @if (responseData && !showUpcomingHotelReservations) {
        <div class="reservation-room-type">
          <gds-wrapper class="gds-wrapper gds-default hydrated">
            <div class="room-type-sec">
              <gds-poi-feature
                [data]="{
                  icon: 'room-type',
                }"
              >
              </gds-poi-feature>
            </div>
          </gds-wrapper>
          <gds-wrapper class="gds-wrapper gds-default hydrated">
            <gds-info-section
              [data]="{
                categorySection: {
                  categoryLabel: pageLabels?.['hotelReservation.categoryLabel'],
                  ariaLabel: pageLabels?.['hotelReservation.categoryLabel'],
                },
              }"
            >
            </gds-info-section>
            <gds-heading
              [data]="{
                heading:
                  getDateLabel(responseData?.check_in_date) +
                  ' -' +
                  getDateLabel(responseData?.check_out_date) +
                  ' ' +
                  getNightsBetweenDates(
                    responseData?.check_in_date,
                    responseData?.check_out_date
                  ),
              }"
              Classes="heading-7"
            ></gds-heading>
            <gds-body
              class="adventure"
              classes="body-2 adventure"
              [data]="{
                description:
                  'Room ' +
                  getRoomTypeCode() +
                  ': [' +
                  getFirstRoomName() +
                  ']',
              }"
            ></gds-body>
          </gds-wrapper>
        </div>
        <gds-spacer classes="spacer-50"></gds-spacer>
      }
    </div>
  </div>
  @if (showVacationPackages) {
    <div class="small-container">
      <div
        class="club-universal contentTab"
        tabindex="0"
        role="button"
        (click)="getReservationDetails('vacation')"
        (keydown.enter)="getReservationDetails('vacation')"
        (keyup.Space)="getReservationDetails('vacation')"
        [attr.aria-label]="pageLabels?.['dashboard.vacation_packages_label']"
      >
        <div class="align-left-hotel" aria-hidden="true">
          <div class="icon-container">
            <gds-svg
              [iconName]="pageLabels?.['dashboard.vacation_packages_icon']"
              height="32"
              width="32"
              fill-color="#222"
              class="adventure"
            ></gds-svg>
            <gds-spacer classes="vertical-spacer-20"></gds-spacer>
          </div>
          <h2>
            <gds-heading
              class="B1-W4"
              classes="adventure"
              [data]="{
                heading: pageLabels?.['dashboard.vacation_packages_label'],
              }"
            ></gds-heading>
          </h2>
          <gds-spacer classes="vertical-spacer-20"></gds-spacer>
          <div class="hotel-icon-names">
            <i aria-hidden="" class="icon icon-arrow-right"></i>
          </div>
        </div>

        <h2 class="details-click" aria-hidden="true">
          <gds-heading
            class="A6-W4 adventure"
            [data]="{
              heading: pageLabels?.['dashboard.see_packages'],
            }"
          ></gds-heading>
        </h2>
      </div>
    </div>
  }
</div>
